import axios, { AxiosResponse } from "axios";
import { captureEvent, setExtra } from "@sentry/react";

import { getPublicTokenForHybrid } from "./getPublicToken";

export const hybrid = axios.create({
	baseURL: process.env.REACT_APP_PRO_API_URL,
});

hybrid.interceptors.request.use(async (config) => {
	if (!config.headers.token && config.url !== "/authenticate/json/v2") {
		const token = await getPublicTokenForHybrid(hybrid);

		config.headers.token = token;
		config.headers.limit = 100000;
	}

	return config;
});

hybrid.interceptors.response.use(undefined, (error) => {
	const response = error.response as AxiosResponse<{
		exception: {
			type: string;
			message: string;
		};
	}>;

	setExtra("ERROR", error);
	setExtra("RESPONSE", response?.data);
	captureEvent({
		message: response?.status ?
			`${response?.status} ${response.data?.exception?.type} ${response.data?.exception?.message}`
			: `${error.message}`,
	});

	return Promise.reject(error);
});
